import { render, staticRenderFns } from "./VerificationPicture.vue?vue&type=template&id=4fca6dfc&scoped=true&"
import script from "./VerificationPicture.vue?vue&type=script&lang=ts&"
export * from "./VerificationPicture.vue?vue&type=script&lang=ts&"
import style0 from "./VerificationPicture.vue?vue&type=style&index=0&id=4fca6dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fca6dfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDialog,VForm,VLayout,VRow})
